import { render, staticRenderFns } from "./BillsDetail.vue?vue&type=template&id=9d356aee&scoped=true&"
import script from "./BillsDetail.vue?vue&type=script&lang=js&"
export * from "./BillsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BillsDetail.vue?vue&type=style&index=0&id=9d356aee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d356aee",
  null
  
)

export default component.exports